import { TFormFields } from 'shared/types/form';
import { TApplicationState } from 'shared/types/redux';

export const selectFormFormFields = (state: TApplicationState): TFormFields => {
  return state.formStatus.formFields;
};
